let _ = require('lodash')
import DesignSystemLines from '@tech_hexeko/design-system/src/lang'

export default _.merge(DesignSystemLines, {
    'fr': require('./fr'),
    'nl': require('./nl'),
    'en': require('./en')
})